export const USER_STORE_KEY = 'currentUser';
export const USER_STATUS_NO_LOGIN = 5112;
export const API_STATUS_KEY = 'code';
